import createCache from '@emotion/cache';

/**
 * Creates an Emotion cache configured to inject styles at the MUI insertion point
 * This ensures MUI/Emotion styles are injected before other styles, preventing FOUC
 * 
 * @returns Emotion cache instance
 */
export default function createEmotionCache() {
  // Find the insertion point in the document head
  const insertionPoint =
    typeof document !== 'undefined'
      ? document.querySelector<HTMLElement>('#mui-insertion-point') || undefined
      : undefined;

  return createCache({
    key: 'mui',
    insertionPoint,
    // Prepend ensures MUI styles come before other styles
    prepend: true,
  });
}
